import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const line = {
  hidden: { y: "115%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, delay: 0.25 + i * 0.15, ease: [0.16, 1, 0.3, 1] } }),
};

export const KineticHero = ({ t }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "25%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section ref={ref} data-testid="hero" className="relative min-h-screen flex flex-col justify-end overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0">
        <div className="absolute inset-0 bg-[#050505]" />
        <img src="/images/hero.png" alt="" className="absolute right-0 top-0 h-full w-full object-cover opacity-60 grayscale-[0.3]" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/20 to-[#050505]/50" />
      </motion.div>

      <motion.div style={{ opacity }} className="relative z-10 max-w-[1600px] mx-auto w-full px-6 md:px-10 pb-16 pt-40">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1, duration: 0.8 }}
          className="text-xs font-mono tracking-[0.2em] uppercase text-[#FF2A00] mb-8" data-testid="hero-overline">
          {t.overline}
        </motion.p>
        <h1 dir="ltr" className="font-display font-black uppercase tracking-tighter leading-[0.85] text-white text-[17vw] md:text-[12vw]" data-testid="hero-title">
          {[t.line1, t.line2].map((l, i) => (
            <span key={l} className="block overflow-hidden pb-[0.06em]">
              <motion.span className="block" custom={i} variants={line} initial="hidden" animate="show">
                {l}{i === 1 && <span className="text-[#FF2A00]">.</span>}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.p initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.9, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10 max-w-xl text-sm md:text-base font-mono tracking-tight text-[#8A8F98] leading-relaxed" data-testid="hero-sub">
          {t.sub}
        </motion.p>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 border-t border-[#272A2E]">
          {t.stats.map((s, i) => (
            <motion.div key={s.l} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.1 + i * 0.12, duration: 0.7 }} data-testid={`hero-stat-${i}`}
              className="pt-6 pr-6 border-r border-[#272A2E] last:border-r-0">
              <p className="font-display text-3xl md:text-4xl font-bold text-white">{s.v}</p>
              <p className="mt-2 text-[10px] md:text-xs font-mono tracking-[0.15em] uppercase text-[#8A8F98]">{s.l}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};
